var StickyLogo = class extends HTMLElement {
    constructor() {
        super();
        // Bind the handler so `this` refers to the component instance
        this.toggleStickyLogo = this.toggleStickyLogo.bind(this);
    }

    connectedCallback() {
        // Cache the container once the element is connected
        this.container = document.querySelector('.section-sticky-logo');
        // Listen for scroll events
        window.addEventListener('scroll', this.toggleStickyLogo);
        this.mobile = window.innerWidth < 999;
        // Initialize the logo size on load
        this.toggleStickyLogo();
        window.addEventListener('resize', () => {
            this.mobile = window.innerWidth < 999;
            this.toggleStickyLogo();
        });
    }

    toggleStickyLogo() {
        if (!this.container) return;

        // Determine how far we've scrolled relative to a viewport percentage
        let scrollLimit;
        let scrollPos;
        let ratio;
        let width;

        if (this.mobile) {
            // 10% of viewport height + padding
            scrollLimit = window.innerHeight * 0.1 + 38;
            scrollPos = Math.min(window.scrollY, scrollLimit);
            ratio = scrollPos / scrollLimit;
            width = 100 - ratio * 72.5; // 100% to 27.5%
        } else {
            // 40% of viewport height + padding
            scrollLimit = window.innerHeight * 0.4 + 38;
            scrollPos = Math.min(window.scrollY, scrollLimit);
            ratio = scrollPos / scrollLimit;
            width = 100 - ratio * 91; // 100% to 9%
        }

        // Find the image inside the component
        const img = this.querySelector('.sticky-logo__image');
        if (img) {
            img.style.width = `${width}%`;
            img.style.height = 'auto';
        }

        // Optional: add/remove a `scrolled` class for other styling
        if (window.scrollY > 0) {
            this.container.classList.add('scrolled');
        } else {
            this.container.classList.remove('scrolled');
        }
    }
};

customElements.define('sticky-logo', StickyLogo);